import { useState } from 'react';
import { EnquiryForm } from '@/components/EnquiryForm';
import { Seo } from '@/components/Seo';

const PHONE = '+44 (0)208 293 3900';
const PHONE_HREF = 'tel:+442082933900';
const EMAIL = 'contact@didiers.co.uk';
const ADDRESS = [
  'Didier\u2019s Patisserie, Unit 5,',
  'Cross Business Park,',
  'Salutation Road,',
  'Greenwich, London,',
  'SE10 0AT',
];
const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent("Didier's Patisserie, Unit 5, Cross Business Park, Salutation Road, Greenwich, London, SE10 0AT");

export function ContactPage() {
  const [openCard, setOpenCard] = useState<'general' | 'career' | null>(null);

  return (
    <div className="page-fade">
      <Seo
        title="Trade Enquiries — Become a Wholesale Customer"
        description="Open a trade account with Didier's Patisserie. Contact our sales team to discuss wholesale supply for your restaurant, hotel or catering business."
        path="/contact"
      />
      <div className="page-head">
        <h1>We would love to hear from you</h1>
        <p className="lede">
          Didier&rsquo;s Patisserie is committed to the highest quality of its products and welcomes any
          feedback in order to maintain the standards it produces for all its customers.
        </p>
      </div>

      <div className="contact-list">
        {/* General Enquiries — dark header, pink body */}
        <div className="contact-card info">
          <div className="contact-card-head">General Enquiries</div>
          <div className="contact-card-body">
            {openCard === 'general' ? (
              <>
                <EnquiryForm type="general" withMessage />
                <button className="contact-back" onClick={() => setOpenCard(null)}>
                  ← Back to details
                </button>
              </>
            ) : (
              <>
                <div className="contact-info">
                  <p>
                    <strong>T:</strong>{' '}
                    <a href={PHONE_HREF}>{PHONE}</a>
                  </p>
                  <p>
                    <strong>E:</strong>{' '}
                    <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                  </p>
                  <p className="contact-address">
                    {ADDRESS.map((line) => (
                      <span key={line}>{line}</span>
                    ))}
                    <a className="contact-map" href={MAP_URL} target="_blank" rel="noopener">
                      View map
                    </a>
                  </p>
                </div>
                <button className="contact-open" onClick={() => setOpenCard('general')}>
                  Make enquiry
                </button>
              </>
            )}
          </div>
        </div>

        {/* Work with us — pink header, dark body */}
        <div className="contact-card flip">
          <div className="contact-card-head">Work with us</div>
          <div className="contact-card-body">
            {openCard === 'career' ? (
              <>
                <EnquiryForm type="career" withMessage withCv />
                <button className="contact-back" onClick={() => setOpenCard(null)}>
                  ← Back
                </button>
              </>
            ) : (
              <>
                <div className="contact-info">
                  <p>To join our team just send us your CV today.</p>
                </div>
                <button className="contact-open" onClick={() => setOpenCard('career')}>
                  Click here
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
